/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_University_PlaceholderInputs */

const en_cv_extract_form_university_placeholder = /** @type {(inputs: Cv_Extract_Form_University_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select your university`)
};

const de_cv_extract_form_university_placeholder = /** @type {(inputs: Cv_Extract_Form_University_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie Ihre Hochschule`)
};

/**
* | output |
* | --- |
* | "Please select your university" |
*
* @param {Cv_Extract_Form_University_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_extract_form_university_placeholder = /** @type {((inputs?: Cv_Extract_Form_University_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_University_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_university_placeholder(inputs)
	return en_cv_extract_form_university_placeholder(inputs)
});